export var PasswordResetIA = function PasswordResetIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return RESET_PASSWORD(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD(strictLocalize), FIRST_STEP_TO_RESET_PASSWORD(strictLocalize), SECOND_STEP_TO_RESET_PASSWORD(strictLocalize), THIRD_STEP_TO_RESET_PASSWORD(strictLocalize), THIS_WILL_SEND_AN_AUTOMATED_EMAIL(strictLocalize)];
    }
  };
};
var RESET_PASSWORD = function RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "8BAYrT",
    defaultMessage: "Reset password"
  });
};
var IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD = function IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "uaYTsO",
    defaultMessage: "If you would like to reset your password, please follow the steps below:"
  });
};
var FIRST_STEP_TO_RESET_PASSWORD = function FIRST_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "FCoWDD",
    defaultMessage: "1. Click the Sign In button in the top right corner of the homepage"
  });
};
var SECOND_STEP_TO_RESET_PASSWORD = function SECOND_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "jmoi8G",
    defaultMessage: "2. Type in your login email address and press enter"
  });
};
var THIRD_STEP_TO_RESET_PASSWORD = function THIRD_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "fMuh5K",
    defaultMessage: "3. On the next screen, click the link that says “Forgot your password? Reset It”"
  });
};
var THIS_WILL_SEND_AN_AUTOMATED_EMAIL = function THIS_WILL_SEND_AN_AUTOMATED_EMAIL(strictLocalize) {
  return strictLocalize({
    id: "NWeLC2",
    defaultMessage: "This will send an automated email to your login email address to help you reset your password. If you do not receive the email, please check if you have spelt your email correctly and check your spam folder. If you have any trouble, please contact us using the options below."
  });
};